// | ------------------------------------------------------------------------
// | Main Navigation
// | ------------------------------------------------------------------------ 


window.addEventListener('load', (event) => {

    // Set variables
    var body = document.querySelector("body");
    var nav = document.querySelector(".main-nav");
    var button = document.querySelector('#mobile-nav-btn');
    var windowWidth = document.body.clientWidth;    

    // Toggle menu function
    var toggleDrawer = function(){
        body.classList.toggle('mobile-nav-open');
        button.classList.toggle('toggled');
        document.documentElement.classList.toggle('no-scroll');                     
    }

    if(nav){

        // Open/close drawer using menu button
        button.addEventListener("click",function(event){
            event.stopPropagation();
            toggleDrawer();
        }, false); 

        // Prevent menu closing when clicked
        nav.addEventListener("click",function(event){
            event.stopPropagation();
        }, false);         

        // Close drawer when clicking off menu
        body.addEventListener("click",function(){
            if (body.classList.contains('mobile-nav-open')) {
                toggleDrawer();
            }
        }, false);        

        // Close drawer if window is resized
        window.addEventListener("resize",function(){
            if(document.body.clientWidth !== windowWidth){
                if (body.classList.contains('mobile-nav-open')) {
                    toggleDrawer();
                }
            }
            windowWidth = document.body.clientWidth;
        });

    }
});